import { CommonContentParams, CommonContentType } from "./common-content.model";

export function getContentKey(params: CommonContentParams): string {
	return params.presenceType ? `${params.presenceType}.${params.contentType}` : `${params.contentType}`;
}

export function getContentParams(key: string): CommonContentParams {
	const keys = key.split(".");
	return keys.length > 1
		? {
				presenceType: keys[0] as string,
				contentType: keys[1] as CommonContentType,
			}
		: { contentType: keys[0] as CommonContentType };
}
